import React from 'react';
import {useIntl} from 'react-intl';
import {useDispatch} from 'react-redux';
import type {AppDispatch} from '@src/client/index';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import {HiInformationCircle} from 'react-icons/hi';
import {setSelectedInfoArticleIdAndFetchArticle} from '../InfoArticle/infoArticleSlice';
import useJoinMessage from '../../../hooks/useJoinMessage';
import './infoButton.less';

interface InfoButtonProps {
    articleId: string;
    aboutText?: string;
    infoKey?: string;
    focusId?: string;
}

export default function InfoButton({
    articleId, aboutText, infoKey, focusId
}: InfoButtonProps) {
    const intl = useIntl();
    const joinMessage = useJoinMessage();

    const dispatch = useDispatch<AppDispatch>();

    function handleClick(e: React.MouseEvent) {
        e.preventDefault();
        e.stopPropagation();
        dispatch(setSelectedInfoArticleIdAndFetchArticle(articleId));
    }

    const additionalText = aboutText ? joinMessage('shared.about', aboutText) : '';
    const buttonLabel = joinMessage('shared.learnMore', additionalText);

    if (!articleId) {
        return null;
    }

    return (
        <Tooltip
            placement="top"
            title={intl.formatMessage({id: 'shared.learnMore', defaultMessage: ''})}
            arrow
        >
            <IconButton
                size="small"
                edge="end"
                color="inherit"
                classes={{root: `info-link ${infoKey}-info-link`}}
                aria-label={buttonLabel}
                onClick={handleClick}
                data-focus-id={focusId}
            >
                <HiInformationCircle
                    className="info-icon"
                    aria-hidden="true"
                />
            </IconButton>
        </Tooltip>
    );
}
